import InnerFitness from "../Home/component/InnerFitness";

export const ROUTE = {
    HOME: "/",
    SIGNUP: "/signup",
    LOGIN: "/login",
    THANKYOU: "/thank-you",
    UPLOADPRESCRIPTION: "/upload-prescription",
    BROCHURES: "/brochures",
    TEAM: "/team",
    DOCTORDETAILS: "/doctor",
    DEPARTMENTDETAILS: "/department",
    DEPARTMENT: "/departments",
    BOOKATEST: "/book-a-test",
    BOOKAPACKAGE: "/health-packages",
    TESTDETAILS: "/test",
    PACKAGEDETAILS: "/package",
    CENTERDETAILS: "/centre",
    CENTER: "/centres",
    DOWNLOADREPORT: "/download-report",
    GENERALENQUIRY: "/general-enquiry",
    OFFER: "/offers",
    TESTIMONIAL: "/testimonials",
    NEWSANDUPDATES: "/news-updates",
    NEWSANDUPDATESDETAIL: "/news-update",
    PRESSREALEASEDETAIL: "/press-release",
    FAQ: "/faq",
    CHECKOUT: "/checkout",
    CORPORATEOFFICE: "/corporate-office",
    SERACHFORTEST: "/search-for-test",
    CUSTOMLANDING: "/custom-landing",
    NATIONREFLAB: "/national-reference-lab",
    ECME: "/ecme",
    CAREER: "/career",
    ENDEVOUR: "/endeavour",
    OVERVIEW: "/overview",
    DIRECTORMESSAGE: "/directors-message",
    ACCREDATITION: "/accreditation",
    QUALITYMANAGEMENT: "/quality-management",
    AWARD: "/award-recognition",
    PRIVACY: "/privacy-policy",
    TERMSCONDITION: "/terms-condition",
    DISCLAIMER: "/disclaimer",
    HEALTHENQUIRY: "/corporate",
    HOMECOLLECTION: "/home-collection",
    BLOODSAMPLEHOMECOLLECTION: "/blood-sample-home-collection",
    BECOMWEPARTNER: "/partner-with-us",
    BECOMEVENDOR: "/vendor-with-us",
    NEUROLOGY: "/neurology",
    ALLERGY: "/allergy",
    MAMAPRINT: "/mamma-print",
    QUICKLINKS: "/quick-links",
    PREVENTIVEHEALTHPKJ: "/preventive-health-check-packages",
    GURUGRAMLAB: "/gurugram-lab",
    BENGALURULAB: "/bengaluru-lab",
    KOLKATALAB: "/kolkata-lab",
    CANCER: '/cancer',
    PRENATALTESTING: '/prenatal-testing',
    LUDHIANALAB: '/ludhiana-lab',
    VIDEOSECTION: '/youtube-video-section',
    CLINICALTRIAL: '/clinical-trial',
    PRIVILEGEMEMBERSHIP: '/privilege-membership-card',
    PRIVILEGEMEMBERSHIPDOCTOR: '/privilege-membership-card-doctor',
    ERRORPAGE: '/404error',
    MYPROFILE: '/my-profile',
    PAYMENT_THANKYOU: "/payment-thank-you",
    PATHLOGYTEST: '/pathology-test',
    DIAGNOSTICCENTERSCITY: "/diagnostic-centres",
    CENTERDETAILSDIAGNOSTIC: "/diagnostic-centres",
    SITEMAP: '/sitemap',
    LifestyleAllergy: '/book-a-test/lifestyle-allergy',
    InnerFitnessCardiac: '/package/inner-fitness-cardiac',
    PreventiveHealthPackage : '/preventive-health-check-packages',
    MammaPrintblue : '/test/mamma-printblue-print-combination'

    // PATHLOGYTESTLOCAL: '/book-a-test',
}